import './index.pcss';
import { renderApp } from './render-app';
import { config } from './config';
window.customApi = {
    init: (configData) => {
        const updatedConfig = config.setConfig(configData);
        renderApp(updatedConfig);
    },
    methods: {},
};
